module.exports = __webpack_public_path__ + "static/img/i2en.09b9c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i2en.png
// module id = cHxH
// module chunks = 0